import { useEffect, useState } from "react";

import type { ConversationLiveState } from "@/api/db/messaging-read";

export function useConversationWindow(state: ConversationLiveState | undefined) {
	const [now, setNow] = useState(Date.now());
	const expires = state?.window_expires_at?.getTime();

	useEffect(() => {
		setNow(Date.now());

		if (!expires) {
			return;
		}

		const minute = setInterval(() => setNow(Date.now()), 60_000);
		const timer = setTimeout(() => setNow(Date.now()), Math.max(0, expires - Date.now()) + 50);
		return () => {
			clearTimeout(timer);
			clearInterval(minute);
		};
	}, [expires]);

	if (!state || !expires) {
		return state;
	}

	const hours = (expires - now) / 3_600_000;

	return { ...state, window_open: hours > 0, window_hours_left: hours > 0 ? hours : null };
}
